export default __webpack_public_path__ + "static/media/OmaduroDoubleToroClosed.4800720c.jpg";